import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63719bad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uploading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uk-icon-spinner uk-icon-spin" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Update", -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!

  return (_openBlock(), _createElementBlock("div", {
    class: "circle-avatar",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeToUpload(true))),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeToUpload(false))),
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickUpload && _ctx.onClickUpload(...args)))
  }, [
    _createVNode(_component_AvatarOrInitials, {
      size: _ctx.width,
      user: _ctx.user
    }, null, 8, ["size", "user"]),
    _createElementVNode("input", {
      ref: "fileInput",
      accept: "image/x-png,image/gif,image/jpeg",
      class: "file-input",
      type: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadAvatar && _ctx.uploadAvatar(...args)))
    }, null, 544),
    (_ctx.savingAvatar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.clickToUpload)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "click-to-upload",
          style: _normalizeStyle(_ctx.uploadSizeStyle)
        }, _hoisted_5, 4))
      : _createCommentVNode("", true)
  ], 32))
}